<template>
  <div>
    <app-spinner v-if="!is_loaded" />
    <template v-else>
      <app-cells>
        <h1 class="title">Cars</h1>
        <app-input
          @input.native="onPlateNumberSearch"
          v-model="search"
          class="input--250"
          type="search"
          placeholder="Search by plate number"
          name="search"
        />
      </app-cells>
      <v-client-table
        :data="table.items"
        :columns="table.columns"
        :options="table.options"
        class="table-default"
        :class="{ 'table-default--loading': table_preloader }"
      >
        <template #h__car_model.name>
          <div class="table-default__left">Car</div>
        </template>
        <template #h__driver>
          <div class="table-default__left">Driver</div>
        </template>
        <template #car_model.name="{ row }">
          <router-link :to="{name: 'car-management-cars-detail-licenses', params: {id: row.id }}" class="table-default__link-border">
            {{ row.car_model.name }} ({{ row.plate_number }})
          </router-link>
        </template>
        <template #driver="{ row }">
          <div class="table-default__left">
            <router-link
              v-if="row.driver"
              :to="{name: 'employees-profile', params: {id: row.driver.id }}"
              class="table-default__link-border"
            >
              {{ row.driver.first_name }} {{ row.driver.last_name }}
            </router-link>
            <span v-else>-</span>
          </div>
        </template>
        <template #odometer="{ row }">
          {{ row.odometer.toLocaleString() }} km
        </template>
      </v-client-table>
      <app-cells position="between">
        <div>
          <paginate
            :clickHandler="onClickPagination"
            v-if="pagination.pages > 1"
            v-model="pagination.page"
            :page-count="pagination.pages"
            :prev-text="'<'"
            :next-text="'>'"
            :container-class="'pagination'"
            :page-class="'pagination__item'"
            :page-link-class="'pagination__link'"
            :prev-class="'pagination__item pagination__item--prev'"
            :next-class="'pagination__item pagination__item--next'"
            :next-link-class="'pagination__link pagination__link--next'"
            :prev-link-class="'pagination__link pagination__link--prev'"
          />
        </div>
        <app-table-records :all="pagination.count" :count="table.items.length" :page="pagination.page" />
      </app-cells>
    </template>
  </div>
</template>

<script>
import { getCarManagementCars } from '@/http'
import debounce from 'lodash/debounce'

export default {
  name: 'CarManagementCarsList',
  data() {
    return {
      is_loaded: false,
      table: {
        items: [],
        columns: ['car_model.name', 'driver', 'odometer'],
        options: {
          headings: {
            'car_model.name': 'Car',
            'driver': 'Driver',
            'odometer': 'Odometer',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 20,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      pagination: {
        pages: 1,
        page: 1,
        count: 1,
      },
      search: '',
      table_preloader: false,
    }
  },
  created() {
    this.fetchItems()
  },
  methods: {
    fetchItems() {
      this.table_preloader = true
      getCarManagementCars({ page: this.pagination.page, page_size: 20, plate_number: this.search })
        .then(response => {
          this.table.items = response.data.results
          this.pagination.pages = response.data.pages
          this.pagination.count = response.data.count
          this.is_loaded = true
          this.table_preloader = false
        })
    },
    onClickPagination(page) {
      this.table_preloader = true
      this.pagination.page = page
      this.fetchItems()
    },
    onPlateNumberSearch() {
      this.searchPlateNumber(this)
    },
    searchPlateNumber: debounce(vm => {
      vm.pagination.page = 1
      vm.fetchItems()
    }, 350),
  }
}
</script>
